module.exports = __webpack_public_path__ + "media/2-83.938f084e.wav";